export default function isRangesOverlapping(x1, x2, y1, y2) {
    return Math.max(Math.min(x1, x2), Math.min(y1, y2)) <= Math.min(Math.max(x1, x2), Math.max(y1, y2));
}
